import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="page page-narrow">
      <div className="empty">
        <h3>Page not found</h3>
        <p className="muted">That link doesn't go anywhere.</p>
        <Link to="/" className="btn">
          Back to your decks
        </Link>
      </div>
    </main>
  );
}
